<sb-dialog-content>
  <div class="flex h-full flex-col items-center justify-center" #iframeContainer>
    @if (loading) {
      <div class="absolute z-base">
        <sb-loading-state class="h-40" />
      </div>
    }
  </div>
</sb-dialog-content>
<sb-dialog-footer class="border-0 border-t border-solid border-default">
  {{ 'You are viewing a product tour' | translate }}
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [color]="'primaryAlt'" (click)="close(false)">
      @if (lastStepReached) {
        {{ 'Close' | translate }}
      } @else {
        {{ 'Skip tour' | translate }}
      }
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
